export class DefaultContentsPageSize {
  pageIndex;
  length;
  pageSize;
  pageSizeOptions;

  constructor(pageSizeData?: any) {
    pageSizeData = pageSizeData || {};
    this.pageIndex = pageSizeData.pageIndex || 1;
    this.length = pageSizeData.length || 0;
    this.pageSize = pageSizeData.pageSize || 50;
    this.pageSizeOptions = pageSizeData.pageSizeOptions || [50, 100, 200];
  }
}
